import { Note } from "@vesatogo/grass-core"

export const InsufficientCreditNote = ({ children }: { children?: any }) => {
  return (
    <Note
      intent="danger"
      className="border-l-4 border-red col-span-4 text-sm my-3"
    >
      Insufficient Credit, adjust trade amount or increase limit to proceed.
      {children}
    </Note>
  )
}
